import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import edit from "../../../assets/svg/vedit.svg";
import del from "../../../assets/svg/vdelete.svg";
import close from "../../../assets/svg/vclose.svg";
import location from "../../../assets/svg/vlocation.svg";
import responsible from "../../../assets/svg/vresponsible.svg";
import shift from "../../../assets/svg/vshift.svg";
import assign from "../../../assets/svg/vresponsible.svg";
import open from "../../../assets/svg/vtime.svg";
import dept from "../../../assets/svg/vdept.svg";
import vendor from "../../../assets/svg/vvendor.svg";
import product from "../../../assets/svg/vproduct.svg";
import print from "../../../assets/svg/vprint.svg";
import download from "../../../assets/svg/vdownload.svg";
import qr from "../../../assets/svg/vqr.png";
import { getDockMasterViewApi } from "../../dock/dock-api";




function DockMasterView({ dockMasterId, onClose, onEdit, onDelete }) {
  const [isClosing, setIsClosing] = useState(false);
  const [dockMasterView, setDockMasterView]=useState([]);

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "stretch",
    zIndex: 1050,
    opacity: isClosing ? 0 : 1,
    transition: "opacity 0.3s ease-out",
  };

  const containerStyle = {
    padding: "24px",
    width: "100%",
    maxWidth: "700px",
    backgroundColor: "#fff",
    height: "100vh",
    overflowY: "auto",
    transform: isClosing ? "translateX(100%)" : "translateX(0)",
    transition: "transform 0.3s ease-out",
    animation: "slideInFromRight 0.3s forwards",
  };

  const styleTag = (
    <style>
      {`
        @keyframes slideInFromRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .custom-scroll::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scroll::-webkit-scrollbar-thumb {
          background: #dcdfe4;
          border-radius: 10px;
        }
        .custom-scroll::-webkit-scrollbar-thumb:hover {
          background: #b1b4b9;
        }
      `}
    </style>
  );

  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  useEffect(() => {
      getDockView();
    }, []);
  
    const getDockView = async () => {
      try {
        const response = await getDockMasterViewApi(`${dockMasterId}`);
        if (response.data.success === true) {
          setDockMasterView(response.data.dock);
        }
        return response.data;
      } catch (err) {
        console.error("Error fetching category:", err);
      } finally {
      }
    };




  return (
    <div style={overlayStyle}>
      {styleTag}
      <div style={containerStyle}>
        <div style={{backgroundColor:"#f8f8f8",width:'100%',height:"fit-content",padding:'24px',display:'flex',flexDirection:'column',gap:"8px",marginBottom:'20px'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontWeight:'800',fontSize:'24px',color:'#172b4d'}}>
              {dockMasterView.display_name || "-"} - <span style={{fontWeight:'800',fontSize:'24px',color:'#172b4d'}}>{dockMasterView.name || "-"}</span>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
              <button onClick={() => onEdit?.(dockMasterId)} style={{background:'none', border:'none', cursor:'pointer', padding:0}} aria-label="Edit">
                <img src={edit} style={{width:'32px',height:'32px'}} alt="edit"/>
              </button>
              <button onClick={() => onDelete?.(dockMasterId)} style={{background:'none', border:'none', cursor:'pointer', padding:0}} aria-label="Delete">
                <img src={del} style={{width:'32px',height:'32px'}} alt="delete"/>
              </button>
              <button onClick={onClose} style={{background:'none', border:'none', cursor:'pointer', padding:0}} aria-label="Close">
                <img src={close} style={{width:'32px',height:'32px'}} alt="close"/>
              </button>
            </div>

          </div>

          <div style={{fontWeight:"700",fontSize:'13px',color:'#212129'}}>
            Code - <span style={{fontWeight:'400',fontSize:"13px",color:'#d35258'}}>{dockMasterView.code || "-"}</span>
          </div>

          <div style={{fontWeight:'400',color:'#8790A1',fontSize:"13px"}}>
            Created on {dockMasterView.created_at ? format(new Date(dockMasterView.created_at), "dd MMM yyyy 'at' hh:mm a") : "-"}
          </div>


        </div>

        <div style={{display:'flex',flexDirection:'column',gap:'24px',marginBottom:'32px'}}>
          <div style={{fontWeight:'600',fontSize:'15px',color:'#172b4d'}}>
            Other details
          </div>
          <div style={{display:'flex',alignItems:"flex-start"}}>
            <div style={{display:'flex',alignItems:'center',gap:'4px',width:'40%'}}>
              <div style={{marginTop:'-2px'}}>
                <img src={location} style={{width:'24px',height:'24px'}} alt="location"/>
              </div>
              <div style={{fontWeight:"400",fontSize:'13px',color:'#172b4d'}}>
                Location
              </div>

            </div>

            <div style={{fontWeight:"500",fontSize:"14px",color:'#172b4d', flex: 1}}>
              {dockMasterView.location || "-"}
            </div>

          </div>
{/* 
          <div style={{display:'flex',alignItems:"center"}}>
            <div style={{display:'flex',alignItems:'center',gap:'4px',width:'40%'}}>
              <div>
                <img src={responsible} style={{width:'24px',height:'24px'}}/>
              </div>
              <div style={{fontWeight:"400",fontSize:'13px',color:'#172b4d'}}>
                Responsible Person
              </div>

            </div>

            <div style={{fontWeight:"500",fontSize:"14px",color:'#172b4d'}}>
              {dockMasterView.users?.map(user => user.label).join(", ") || "-"}
            </div>

          </div> */}

          {/* <div style={{display:'flex',alignItems:"center"}}>
            <div style={{display:'flex',alignItems:'center',gap:'4px',width:'40%'}}>
              <div>
                <img src={shift} style={{width:'24px',height:'24px'}}/>
              </div>
              <div style={{fontWeight:"400",fontSize:'13px',color:'#172b4d'}}>
                Shift
              </div>

            </div>

            <div style={{fontWeight:"500",fontSize:"14px",color:'#172b4d'}}>
              {dockMasterView.shift || "-"}
            </div>

          </div> */}

          <div style={{display:'flex',alignItems:"flex-start"}}>
            <div style={{display:'flex',alignItems:'center',gap:'4px',width:'40%'}}>
              <div style={{marginTop:'-2px'}}>
                <img src={assign} style={{width:'24px',height:'24px'}} alt="assign"/>
              </div>
              <div style={{fontWeight:"400",fontSize:'13px',color:'#172b4d'}}>
                Assign To
              </div>

            </div>

            <div className="custom-scroll" style={{fontWeight:"500",fontSize:"14px",color:'#172b4d', flex: 1, maxHeight: '60px', overflowY: 'auto'}}>
              {dockMasterView.users?.map(user => user.label).join(", ") || "-"}
            </div>

          </div>

          <div style={{display:'flex',alignItems:"flex-start"}}>
            <div style={{display:'flex',alignItems:'center',gap:'4px',width:'40%'}}>
              <div style={{marginTop:'-2px'}}>
                <img src={open} style={{width:'24px',height:'24px'}} alt="time"/>
              </div>
              <div style={{fontWeight:"400",fontSize:'13px',color:'#172b4d'}}>
                Open & close Time
              </div>

            </div>

            <div style={{fontWeight:"500",fontSize:"14px",color:'#172b4d', flex: 1}}>
              {dockMasterView.available_in_time || "-"} - {dockMasterView.available_out_time || "-"}
            </div>

          </div>

          <div style={{display:'flex',alignItems:"flex-start"}}>
            <div style={{display:'flex',alignItems:'center',gap:'4px',width:'40%'}}>
              <div style={{marginTop:'-2px'}}>
                <img src={dept} style={{width:'24px',height:'24px'}} alt="department"/>
              </div>
              <div style={{fontWeight:"400",fontSize:'13px',color:'#172b4d'}}>
                Department
              </div>

            </div>

            <div className="custom-scroll" style={{fontWeight:"500",fontSize:"14px",color:'#172b4d', flex: 1, maxHeight: '60px', overflowY: 'auto'}}>
              {dockMasterView.departments?.map(dept => dept.label).join(", ") || "-"}
            </div>

          </div>

          <div style={{display:'flex',alignItems:"flex-start"}}>
            <div style={{display:'flex',alignItems:'center',gap:'4px',width:'40%'}}>
              <div style={{marginTop:'-2px'}}>
                <img src={vendor} style={{width:'24px',height:'24px'}} alt="vendor"/>
              </div>
              <div style={{fontWeight:"400",fontSize:'13px',color:'#172b4d'}}>
                Vendor
              </div>

            </div>

            <div style={{fontWeight:"500",fontSize:"14px",color:'#172b4d', flex: 1}}>
              {dockMasterView.vendors?.map(v => v.label).join(", ") || "-"}
            </div>

          </div>

          <div style={{display:'flex',alignItems:"flex-start"}}>
            <div style={{display:'flex',alignItems:'center',gap:'4px',width:'40%'}}>
              <div style={{marginTop:'-2px'}}>
                <img src={location} style={{width:'24px',height:'24px'}} alt="product"/>
              </div>
              <div style={{fontWeight:"400",fontSize:'13px',color:'#172b4d'}}>
                Product type
              </div>

            </div>

            <div style={{fontWeight:"500",fontSize:"14px",color:'#172b4d', flex: 1}}>
              {dockMasterView.product_types?.map(p => p.label).join(", ") || "-"}
            </div>

          </div>

        </div>

        <div style={{paddingRight:'24px',display:'flex',flexDirection:'column',gap:'16px',marginBottom:'40px'}}>
          <div style={{fontWeight:'600',fontSize:'15px',color:'#172b4d'}}>
            Description
          </div>

          <div style={{fontWeight:'500',fontSize:'14px',color:'#172b4d'}}>
            {dockMasterView.description || "-"}
          </div>

        </div>

        <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
          <div style={{fontWeight:'700',fontSize:'16px',color:'#172b4d'}}>
            Dock out QR code
          </div>

          <div style={{display:'flex',alignItems:'center',gap:'16px'}}>
            <div>
              <img src={dockMasterView.qr} style={{width:'160px',height:'160px'}}/>
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',borderRadius:'100px',padding:'18px 16px',backgroundColor:'#f7f8f9',height:'40px',boxShadow: "0px 0px 2px 0px #0000001F"}}>
                <div>
                  <img src={download} style={{width:'16px'}}/>
                </div>
                <div style={{fontWeight:"600",fontSize:'14px',color:'#172b4d'}}>
                  Download
                </div>

              </div>
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',borderRadius:'100px',padding:'18px 16px',backgroundColor:'#f7f8f9',height:'40px',boxShadow: "0px 0px 2px 0px #0000001F"}}>
                <div>
                  <img src={print} style={{width:'16px'}}/>
                </div>
                <div style={{fontWeight:"600",fontSize:'14px',color:'#172b4d'}}>
                  Print
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

DockMasterView.propTypes = {
  dockMasterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default DockMasterView;
